var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackLinkedinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.776 0.892578H2.13996C1.48796 0.892578 0.959961 1.39158 0.959961 2.00858V15.2576C0.959961 15.8746 1.48796 16.3766 2.14096 16.3766H15.776C16.429 16.3766 16.96 15.8746 16.96 15.2606V2.00858C16.96 1.39158 16.429 0.892578 15.776 0.892578ZM5.70596 14.0876H3.33296V6.69558H5.70796V14.0876H5.70596ZM4.51996 5.68858C3.75796 5.68858 3.14196 5.09358 3.14196 4.35858C3.14196 3.62358 3.75796 3.02858 4.51996 3.02858C5.27996 3.02858 5.89496 3.62358 5.89496 4.35858C5.89496 5.09058 5.27996 5.68858 4.51996 5.68858ZM14.595 14.0876H12.224V10.4946C12.224 9.63858 12.208 8.53458 10.989 8.53458C9.75496 8.53458 9.56696 9.46958 9.56696 10.4346V14.0876H7.19696V6.69558H9.47196V7.70558H9.50396C9.81896 7.12558 10.594 6.51158 11.748 6.51158C14.151 6.51158 14.594 8.04158 14.594 10.0316V14.0876H14.595Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLinkedinIcon);
export default __webpack_public_path__ + "static/media/BlackLinkedinIcon.4305eed13563a7a78e029669c4afb54f.svg";
export { ForwardRef as ReactComponent };